
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import ObjectInfoCategoryParcel from './ObjectInfoCategoryParcel';
import ObjectInfoListParcel from './ObjectInfoListParcel';
import ObjectInfoSelection from './ObjectInfoSelection';
import ToolsButton from './ToolsButton';

const classNames = mergeStyleSets({
    root: {
        padding: 16,
        width: 400
    }
});

const ToolsPanel = (props) => {

    return (
        <Stack tokens={{childrenGap: 16}} className={classNames.root}>
            <ObjectInfoListParcel />
            <ObjectInfoCategoryParcel />
            <ObjectInfoSelection />
            <ToolsButton />
        </Stack>
    );
}

export default ToolsPanel;
